var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"module-content module-health-audit"},[_c('div',{staticClass:"row"},[_c('HeaderTopBar')],1),_c('ActiveErrors'),_c('div',{staticClass:"row divider"}),_c('ResolvedErrors')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }